(function () {
  'use strict';

  function route(name, fallback) {
    return (window.Axiom && window.Axiom.routes && window.Axiom.routes[name]) || fallback;
  }

  function cartString(key, fallback) {
    return ((window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings[key]) || fallback || '').toString();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function parseCountryProvinces(option) {
    if (!option) return [];
    var raw = option.getAttribute('data-provinces');
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }

  // Start from the shopper's country (Shopify localization) instead of "---". The options
  // carry Shopify's country names, the same names localization.country.name gives.
  function selectDefaultCountry(root) {
    var countrySelect = root && root.querySelector('[data-cart-shipping-country]');
    var defaultCountry = countrySelect && countrySelect.dataset.defaultCountry;
    if (!defaultCountry || countrySelect.selectedIndex > 0) return;
    var match = Array.prototype.find.call(countrySelect.options, function (option) {
      return option.value === defaultCountry || option.textContent.trim() === defaultCountry;
    });
    if (match) countrySelect.value = match.value;
  }

  function updateProvinceSelect(root) {
    if (!root) return;
    var countrySelect = root.querySelector('[data-cart-shipping-country]');
    var provinceContainer = root.querySelector('[data-cart-shipping-province-container]');
    var provinceSelect = root.querySelector('[data-cart-shipping-province]');
    if (!countrySelect || !provinceContainer || !provinceSelect) return;

    var provinces = parseCountryProvinces(countrySelect.options[countrySelect.selectedIndex]);
    provinceSelect.innerHTML = '';
    if (!provinces.length) {
      provinceContainer.hidden = true;
      provinceSelect.value = '';
      return;
    }

    provinces.forEach(function (province) {
      var option = document.createElement('option');
      option.value = province[0];
      option.textContent = province[1];
      provinceSelect.appendChild(option);
    });
    provinceContainer.hidden = false;
  }

  function buildQuery(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    params.set('shipping_address[country]', String(data.get('country') || '').trim());
    params.set('shipping_address[province]', String(data.get('province') || '').trim());
    params.set('shipping_address[zip]', String(data.get('zip') || '').trim());
    return params.toString();
  }

  function prepareRates(query) {
    return fetch(route('root', '/') + 'cart/prepare_shipping_rates.json?' + query, {
      method: 'POST',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (error) { throw error; });
      return null;
    });
  }

  function fetchRates(query) {
    return fetch(route('root', '/') + 'cart/async_shipping_rates.json?' + query, {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (error) { throw error; });
      return response.json();
    });
  }

  function pollRates(query, attempts) {
    attempts = attempts || 0;
    return fetchRates(query).then(function (result) {
      if (result && result.shipping_rates) return result.shipping_rates;
      if (attempts >= 8) return null;
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 500);
      }).then(function () {
        return pollRates(query, attempts + 1);
      });
    });
  }

  function parseRateCents(rate) {
    var raw = rate && rate.price;
    var amount = typeof raw === 'number' ? raw : parseFloat(String(raw || '').replace(/[^0-9.-]/g, ''));
    if (!Number.isFinite(amount)) return null;
    return Math.round(amount * 100);
  }

  function hasFreeRate(rates) {
    return Array.isArray(rates) && rates.some(function (rate) {
      return parseRateCents(rate) === 0;
    });
  }

  function formatRatePrice(rate) {
    var cents = parseRateCents(rate);
    if (cents === null) return escapeHtml(rate && rate.price ? rate.price : '');
    if (window.Axiom && typeof window.Axiom.formatMoney === 'function') {
      return escapeHtml(window.Axiom.formatMoney(cents));
    }
    return escapeHtml(String(rate && rate.price ? rate.price : ''));
  }

  function renderInitialResults(container) {
    if (!container) return;
    var message = escapeHtml(container.dataset.shippingPrompt || cartString('shippingEstimatorPrompt'));
    var policyUrl = container.dataset.shippingPolicyUrl || cartString('shippingPolicyUrl', '');
    var policyLabel = escapeHtml(cartString('shippingEstimatorPolicy'));
    var policyHtml = policyUrl ? '<a href="' + escapeHtml(policyUrl) + '" class="cart-shipping-estimator__link">' + policyLabel + '</a>' : '';
    container.innerHTML = '<p>' + message + '</p>' + policyHtml;
  }

  function renderLoading(container) {
    if (!container) return;
    container.innerHTML = '<p>' + escapeHtml(cartString('shippingEstimatorLoading')) + '</p>';
  }

  // Shopify answers an address it can't rate with its reasons per field, already written
  // for the shopper's language and country ({"zip": ["Enter a ZIP code"]}). Whether a
  // postal code is needed depends on the country, so Shopify decides, not the form.
  function addressErrorMessages(error) {
    if (!error || typeof error !== 'object') return [];
    return Object.keys(error).reduce(function (messages, field) {
      return messages.concat(error[field]);
    }, []).filter(function (message) {
      return typeof message === 'string' && message;
    });
  }

  function renderError(container, error) {
    if (!container) return;
    var messages = addressErrorMessages(error);
    if (!messages.length) messages = [cartString('shippingEstimatorError')];
    container.innerHTML = messages.map(function (message) {
      return '<p>' + escapeHtml(message) + '</p>';
    }).join('');
  }

  function renderRates(container, rates) {
    if (!container) return;
    if (!rates) {
      renderLoading(container);
      return;
    }
    if (!rates.length) {
      container.innerHTML = '<p>' + escapeHtml(cartString('shippingEstimatorNoRates')) + '</p>';
      return;
    }

    var freeAvailable = hasFreeRate(rates);
    var statusText = freeAvailable
      ? cartString('shippingEstimatorFree')
      : cartString('shippingEstimatorPaid');

    container.innerHTML =
      '<p class="cart-shipping-estimator__message' + (freeAvailable ? ' cart-shipping-estimator__message--success' : '') + '">' + escapeHtml(statusText) + '</p>' +
      '<ul class="cart-shipping-estimator__rates">' +
        rates.map(function (rate) {
          return '<li class="cart-shipping-estimator__rate"><span>' + escapeHtml(rate.presentment_name || rate.name || '') + '</span><span>' + formatRatePrice(rate) + '</span></li>';
        }).join('') +
      '</ul>';
  }

  function bindEstimator(root) {
    if (!root || root.dataset.cartShippingBound === 'true') return;
    root.dataset.cartShippingBound = 'true';

    var form = root.querySelector('[data-cart-shipping-form]');
    var results = root.querySelector('[data-cart-shipping-results]');
    if (!form || !results) return;

    renderInitialResults(results);
    selectDefaultCountry(root);
    updateProvinceSelect(root);

    root.addEventListener('change', function (event) {
      if (event.target.closest('[data-cart-shipping-country]')) {
        updateProvinceSelect(root);
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var submit = form.querySelector('[type="submit"]');
      var query = buildQuery(form);
      if (submit) submit.disabled = true;
      renderLoading(results);
      prepareRates(query)
        .then(function () {
          return pollRates(query, 0);
        })
        .then(function (rates) {
          renderRates(results, rates);
        })
        .catch(function (error) {
          if (!addressErrorMessages(error).length) console.error('Cart shipping rates error:', error);
          renderError(results, error);
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function init(scope) {
    var root = scope && scope.querySelector ? scope : document;
    if (root.matches && root.matches('[data-cart-shipping-estimator]')) bindEstimator(root);
    root.querySelectorAll('[data-cart-shipping-estimator]').forEach(bindEstimator);
  }

  window.Axiom = Object.assign(window.Axiom || {}, {
    initCartShippingEstimators: init,
    updateCartShippingProvinceSelect: updateProvinceSelect,
    renderCartShippingInitial: renderInitialResults
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
